if (!customElements.get('m-editorial-center-slider')) {
  class MEditorialCenterSlider extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.init();
    }

    init() {
      const SwiperClass = (window.MinimogLibs && window.MinimogLibs.Swiper) || window.Swiper;
      if (!SwiperClass) {
        window.setTimeout(() => this.init(), 200);
        return;
      }

      this.container = this.querySelector('.swiper');
      if (!this.container) return;

      this.prevButtons = this.querySelectorAll('[data-ecs-prev]');
      this.nextButtons = this.querySelectorAll('[data-ecs-next]');

      const autoplay = this.dataset.autoplay === 'true';
      const delay = parseInt(this.dataset.delay || '5', 10) * 1000;
      const speed = parseInt(this.dataset.speed || '800', 10);
      const space = parseInt(this.dataset.space || '30', 10);
      const mobileSpace = parseInt(this.dataset.mobileSpace || '16', 10);
      const loop = this.dataset.loop !== 'false';

      this.swiper = new SwiperClass(this.container, {
        loop,
        speed,
        centeredSlides: true,
        slidesPerView: 1.08,
        spaceBetween: mobileSpace,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        autoplay: autoplay
          ? {
              delay,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }
          : false,
        pagination: {
          el: this.querySelector('.ecs__pagination'),
          clickable: true,
          bulletClass: 'ecs-dot',
          bulletActiveClass: 'is-active',
        },
        breakpoints: {
          768: {
            slidesPerView: 'auto',
            spaceBetween: space,
          },
        },
      });

      this.prevButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          this.swiper.slidePrev();
        });
      });

      this.nextButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          this.swiper.slideNext();
        });
      });
    }

    disconnectedCallback() {
      if (this.swiper && typeof this.swiper.destroy === 'function') {
        this.swiper.destroy(true, true);
      }
      this.initialized = false;
    }
  }

  customElements.define('m-editorial-center-slider', MEditorialCenterSlider);
}
